/**
 * @fileoverview The quick-note shortcuts' one rule: a tapped shortcut joins what is
 * already written rather than replacing it, and never past a note's length.
 *
 * Its own file so the journal and the photo note share it without importing
 * each other's components.
 *
 * Where: the plant and bed journal (NotesSection) and the bed note panel
 * (BedActions). A to-do title uses shortcutText directly (its own limit).
 * API: none.
 * Settings: the server's limits.NOTE_MAX_LENGTH (lib/growSettings).
 *
 * @module noteShortcut
 */

import { growLimit } from '@/shared/lib/growSettings';
import { joinShortcut } from '@/shared/lib/shortcutText';

/**
 * A shortcut added to what is already written: taps build one sentence.
 *
 * @param current - What the note says so far.
 * @param label - The shortcut's words.
 * @returns The note with the shortcut on the end, cut to the server's limits.NOTE_MAX_LENGTH (uncut before the app has heard it, when the server's refusal stands).
 */
export function withShortcut(current: string, label: string): string {
  return joinShortcut(current, label, growLimit('NOTE_MAX_LENGTH'));
}
